// chartConfig.ts
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  BarElement,
  Filler,
  Tooltip,
  Legend,
  Plugin,
} from "chart.js";

export const glowPointPlugin: Plugin<"line"> = {
  id: "glowPoint",
  afterDatasetsDraw(chart) {
    if ((chart.config as any).type !== "line") {
      return;
    }

    const { ctx, data } = chart;
    data.datasets.forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex);
      meta.data.forEach((element) => {
        const { x, y } = (element as any).getProps(["x", "y"], true);

        ctx.save();
        ctx.shadowColor = "#FF68D5";
        ctx.shadowBlur = 10;
        ctx.beginPath();
        ctx.arc(x, y, 6, 0, 2 * Math.PI);
        ctx.fillStyle = "#fff";
        ctx.fill();
        ctx.restore();

        ctx.beginPath();
        ctx.arc(x, y, 6, 0, 2 * Math.PI);
        ctx.lineWidth = 2;
        ctx.strokeStyle = "#FF68D5";
        ctx.stroke();
      });
    });
  },
};

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  BarElement,
  Filler,
  Tooltip,
  Legend,
  glowPointPlugin,
);
